import React, { useState } from 'react';
import './manageCommittee.css';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Swal from 'sweetalert2';

const UpdateCommittee = () => {
    let navigate = useNavigate();
    const [formData, setFormData] = useState({
        committeeName: "",
        members: [{
            name: '',
            affiliation: '',
            email: '',
            designation: "",
            convenor:"",
        }],

    });
    const [subcommittee, setSubCommittee] = useState({
        subCommitteeName: "",
        subCommitteeMembers: []
    })
    const addFields = () => {
        let object = {
            name: '',
            affiliation: '',
            email: '',
            designation: "",
            convenor:"",
        }
        let members = [...formData['members'], object]
        setFormData({ ...formData, members })
     
    }
    
    const removeMember = (index) => {
        if (formData.members.length > 1) {
            let members = [...formData.members];
            members.splice(index, 1);
            setFormData({ ...formData, members });
        }
    }
    
    const addSubCommittee = () => {
        let object = {
            name: '',
            affiliation: '',
            email: '',
            designation: ""
        }
        let subCommitteeMembers = [...subcommittee['subCommitteeMembers'], object]
        setSubCommittee({ ...subcommittee, subCommitteeMembers })
     
    }
    const handleAddingSubCommittee = () => {
        let object = {
            name: '',
            affiliation: '',
            email: '',
            designation: ""
        }
        let subCommitteeMembers = [...subcommittee['subCommitteeMembers'], object]
        setSubCommittee({ ...subcommittee, subCommitteeMembers })
       
    }
    
    const removeSubCommitteeMember = (index) => {
        if (subcommittee.subCommitteeMembers.length > 1) {
            let subCommitteeMembers = [...subcommittee.subCommitteeMembers];
            subCommitteeMembers.splice(index, 1);
            setSubCommittee({ ...subcommittee, subCommitteeMembers });
        }
    }
    const handleFormChange = (event, index) => {
        let data = [...formData['members']];
        data[index][event.target.name] = event.target.value;
        setFormData({ ...formData, members: data });
    }
    const handleSubCommitteeMember = (event, index) => {
        let data = [...subcommittee['subCommitteeMembers']];
        data[index][event.target.name] = event.target.value;
        setSubCommittee({ ...subcommittee, subCommitteeMembers: data });
    }
    const handleCommitteeName = (event) => {
        let committeeName = event.target.value;
        setFormData({ ...formData, committeeName })
      
    }
    const handleSubCommitteeName = (event) => {
        let subCommitteeName = event.target.value;
        setSubCommittee({ ...subcommittee, subCommitteeName })
    }
    
    const validateForm = () => {
        // Validate Committee Name
        if (!formData.committeeName || formData.committeeName.trim() === '') {
            Swal.fire({
                icon: 'warning',
                title: 'Validation Error',
                text: 'Please enter committee name!',
                confirmButtonColor: '#5e71f6',
            });
            return false;
        }

        // Validate Main Committee Members
        for (let i = 0; i < formData.members.length; i++) {
            const member = formData.members[i];
            if (!member.name || member.name.trim() === '') {
                Swal.fire({
                    icon: 'warning',
                    title: 'Validation Error',
                    text: `Please enter name for Main Committee Member #${i + 1}!`,
                    confirmButtonColor: '#5e71f6',
                });
                return false;
            }
            if (!member.affiliation || member.affiliation.trim() === '') {
                Swal.fire({
                    icon: 'warning',
                    title: 'Validation Error',
                    text: `Please enter affiliation for Main Committee Member #${i + 1}!`,
                    confirmButtonColor: '#5e71f6',
                });
                return false;
            }
            if (!member.email || member.email.trim() === '') {
                Swal.fire({
                    icon: 'warning',
                    title: 'Validation Error',
                    text: `Please enter email for Main Committee Member #${i + 1}!`,
                    confirmButtonColor: '#5e71f6',
                });
                return false;
            }
            // Email format validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(member.email)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Validation Error',
                    text: `Please enter a valid email for Main Committee Member #${i + 1}!`,
                    confirmButtonColor: '#5e71f6',
                });
                return false;
            }
            if (!member.designation || member.designation === '') {
                Swal.fire({
                    icon: 'warning',
                    title: 'Validation Error',
                    text: `Please select designation for Main Committee Member #${i + 1}!`,
                    confirmButtonColor: '#5e71f6',
                });
                return false;
            }
        }

        // Validate Subcommittee if exists
        if (subcommittee.subCommitteeMembers.length > 0) {
            if (!subcommittee.subCommitteeName || subcommittee.subCommitteeName.trim() === '') {
                Swal.fire({
                    icon: 'warning',
                    title: 'Validation Error',
                    text: 'Please enter subcommittee name!',
                    confirmButtonColor: '#5e71f6',
                });
                return false;
            }

            for (let i = 0; i < subcommittee.subCommitteeMembers.length; i++) {
                const member = subcommittee.subCommitteeMembers[i];
                if (!member.name || member.name.trim() === '') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Validation Error',
                        text: `Please enter name for Subcommittee Member #${i + 1}!`,
                        confirmButtonColor: '#5e71f6',
                    });
                    return false;
                }
                if (!member.affiliation || member.affiliation.trim() === '') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Validation Error',
                        text: `Please enter affiliation for Subcommittee Member #${i + 1}!`,
                        confirmButtonColor: '#5e71f6',
                    });
                    return false;
                }
                if (!member.email || member.email.trim() === '') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Validation Error',
                        text: `Please enter email for Subcommittee Member #${i + 1}!`,
                        confirmButtonColor: '#5e71f6',
                    });
                    return false;
                }
                // Email format validation
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(member.email)) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Validation Error',
                        text: `Please enter a valid email for Subcommittee Member #${i + 1}!`,
                        confirmButtonColor: '#5e71f6',
                    });
                    return false;
                }
                if (!member.designation || member.designation.trim() === '') {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Validation Error',
                        text: `Please enter designation for Subcommittee Member #${i + 1}!`,
                        confirmButtonColor: '#5e71f6',
                    });
                    return false;
                }
            }
        }

        return true;
    }
    
    const CreatingCommitteeAndSubCommittee = () => {
        // Validate form before submission
        if (!validateForm()) {
            return;
        }
        
        let committeeData = {
            mainCommittee: formData,
            subCommittee: subcommittee
        }
     

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#008000',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes !'
        }).then(async (result) => {
            if (result.isConfirmed) {
                axios.post(`${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/create-committee`, committeeData)
                      .then(function (response) {
                        Swal.fire(
                          'Uploaded!',
                          'Committee Creation Completed!',
                          'success'
                        )
                     
                        navigate('/committee');
                      })
                      .catch(function (error) {
                        Swal.fire({
                          position: 'top-end',
                          icon: 'error',
                          title: 'Committee Creation Failed',
                          showConfirmButton: false,
                          timer: 1500
                        })
                      });

            }
        })
        
    }
    return (
        <div className='manage-committee-wrapper'>
            <div className='manage-committee-container'>
                {/* Header Section */}
                <div className='committee-header-section'>
                    <h1 className='committee-page-title'>Committee Management</h1>
                    <p className='committee-page-subtitle'>Create and manage committee and subcommittee members</p>
                </div>

                {/* Main Committee Card */}
                <div className='committee-card'>
                    <div className='committee-card-header'>
                        <h2 className='committee-card-title'>
                            <svg className="committee-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                            Main Committee
                        </h2>
                    </div>

                    {/* Committee Name Input */}
                    <div className='committee-name-section'>
                        <div className='committee-form-group'>
                            <label htmlFor="committeeName" className='committee-form-label'>
                                Committee Name <span className="required">*</span>
                            </label>
                            <input 
                                type="text" 
                                id="committeeName" 
                                name="committeeName" 
                                className='committee-form-input'
                                placeholder='Enter committee name...'
                                onChange={(e) => handleCommitteeName(e)} 
                            />
                        </div>
                    </div>

                    {/* Committee Members */}
                    {formData.members.map((val, index) => (
                        <div key={index} className='member-card'>
                            <div className='member-card-header'>
                                <div className='member-badge'>
                                    <svg className="button-icon-committee" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                    Member #{index + 1}
                                </div>
                                {formData.members.length > 1 && (
                                    <button 
                                        onClick={() => removeMember(index)} 
                                        className="remove-member-button"
                                        title="Remove member"
                                    >
                                        <svg className="button-icon-committee" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                        </svg>
                                    </button>
                                )}
                            </div>

                            <div className='member-fields'>
                                <div className='committee-form-group'>
                                    <label htmlFor={`name-${index}`} className='committee-form-label'>
                                        Name <span className="required">*</span>
                                    </label>
                                    <input 
                                        type="text" 
                                        id={`name-${index}`}
                                        name="name" 
                                        className='committee-form-input'
                                        placeholder='Enter member name...'
                                        onChange={(e) => handleFormChange(e, index)} 
                                    />
                                </div>

                                <div className='committee-form-group'>
                                    <label htmlFor={`affiliation-${index}`} className='committee-form-label'>
                                        Affiliation <span className="required">*</span>
                                    </label>
                                    <input 
                                        type="text" 
                                        id={`affiliation-${index}`}
                                        name="affiliation" 
                                        className='committee-form-input'
                                        placeholder='Enter affiliation...'
                                        onChange={(e) => handleFormChange(e, index)} 
                                    />
                                </div>

                                <div className='committee-form-group'>
                                    <label htmlFor={`email-${index}`} className='committee-form-label'>
                                        Email <span className="required">*</span>
                                    </label>
                                    <input 
                                        type="email" 
                                        id={`email-${index}`}
                                        name="email" 
                                        className='committee-form-input'
                                        placeholder='Enter email address...'
                                        onChange={(e) => handleFormChange(e, index)} 
                                    />
                                </div>

                                <div className='committee-form-group'>
                                    <label htmlFor={`designation-${index}`} className='committee-form-label'>
                                        Designation <span className="required">*</span>
                                    </label>
                                    <select 
                                        id={`designation-${index}`}
                                        name="designation" 
                                        className='committee-form-select'
                                        onChange={(e) => handleFormChange(e, index)}
                                    >
                                        <option value="" disabled selected>Select designation</option>
                                        <option value="convenor">Convenor</option>
                                        <option value="member">Member</option>
                                        <option value="member-secretary">Member-Secretary</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className='button-container-right'>
                        <button onClick={addFields} className="add-member-button">
                            <svg className="button-icon-committee" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                            </svg>
                            Add New Member
                        </button>
                    </div>
                </div>

                {/* Subcommittee Section */}
                <section className='subcommittee-section'>
                    {subcommittee.subCommitteeMembers.length === 0 && (
                        <div className='add-subcommittee-container'>
                            <button onClick={addSubCommittee} className="add-subcommittee-button">
                                <svg className="button-icon-committee" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                </svg>
                                Add Subcommittee
                            </button>
                        </div>
                    )}

                    {subcommittee.subCommitteeMembers.length > 0 && (
                        <div className='committee-card'>
                            <div className='committee-card-header'>
                                <h2 className='committee-card-title'>
                                    <svg className="committee-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                    </svg>
                                    Subcommittee
                                </h2>
                            </div>

                            <div className='committee-name-section'>
                                <div className='committee-form-group'>
                                    <label htmlFor="subcommitteeName" className='committee-form-label'>
                                        Subcommittee Name <span className="required">*</span>
                                    </label>
                                    <input 
                                        type="text" 
                                        id="subcommitteeName"
                                        name="subcommitteeName" 
                                        className='committee-form-input'
                                        placeholder='Enter subcommittee name...'
                                        onChange={(e) => handleSubCommitteeName(e)} 
                                    />
                                </div>
                            </div>

                            {subcommittee.subCommitteeMembers.map((val, index) => (
                                <div key={index} className='member-card'>
                                    <div className='member-card-header'>
                                        <div className='member-badge'>
                                            <svg className="button-icon-committee" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                            Member #{index + 1}
                                        </div>
                                        {subcommittee.subCommitteeMembers.length > 1 && (
                                            <button 
                                                onClick={() => removeSubCommitteeMember(index)} 
                                                className="remove-member-button"
                                                title="Remove member"
                                            >
                                                <svg className="button-icon-committee" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                            </button>
                                        )}
                                    </div>

                                    <div className='member-fields'>
                                        <div className='committee-form-group'>
                                            <label htmlFor={`sub-name-${index}`} className='committee-form-label'>
                                                Name <span className="required">*</span>
                                            </label>
                                            <input 
                                                type="text" 
                                                id={`sub-name-${index}`}
                                                name="name" 
                                                className='committee-form-input'
                                                placeholder='Enter member name...'
                                                onChange={(e) => handleSubCommitteeMember(e, index)} 
                                            />
                                        </div>

                                        <div className='committee-form-group'>
                                            <label htmlFor={`sub-affiliation-${index}`} className='committee-form-label'>
                                                Affiliation <span className="required">*</span>
                                            </label>
                                            <input 
                                                type="text" 
                                                id={`sub-affiliation-${index}`}
                                                name="affiliation" 
                                                className='committee-form-input'
                                                placeholder='Enter affiliation...'
                                                onChange={(e) => handleSubCommitteeMember(e, index)} 
                                            />
                                        </div>

                                        <div className='committee-form-group'>
                                            <label htmlFor={`sub-email-${index}`} className='committee-form-label'>
                                                Email <span className="required">*</span>
                                            </label>
                                            <input 
                                                type="email" 
                                                id={`sub-email-${index}`}
                                                name="email" 
                                                className='committee-form-input'
                                                placeholder='Enter email address...'
                                                onChange={(e) => handleSubCommitteeMember(e, index)} 
                                            />
                                        </div>

                                        <div className='committee-form-group'>
                                            <label htmlFor={`sub-designation-${index}`} className='committee-form-label'>
                                                Designation <span className="required">*</span>
                                            </label>
                                            <input 
                                                type="text" 
                                                id={`sub-designation-${index}`}
                                                name="designation" 
                                                className='committee-form-input'
                                                placeholder='Enter designation...'
                                                onChange={(e) => handleSubCommitteeMember(e, index)} 
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <div className='button-container-right'>
                                <button onClick={handleAddingSubCommittee} className="add-member-button">
                                    <svg className="button-icon-committee" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                                    </svg>
                                    Add More Member
                                </button>
                            </div>
                        </div>
                    )}
                </section>

                {/* Submit Button */}
                <div className='committee-submit-container'>
                    <button className="committee-submit-btn" onClick={CreatingCommitteeAndSubCommittee}>
                        <svg className="button-icon-committee" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        Submit Committee
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpdateCommittee;